<div class="grid flex-row flex-wrap gap-4 md:grid-cols-2">
  <div class="flex grow flex-col gap-2 rounded-md bg-white p-4 shadow-md">
    <div class="flex flex-row items-center gap-4">
      <h3 class="!m-0 flex grow !font-bold">Settings</h3>
      <mat-icon
        class="icon-sm hover:text-primary-500 cursor-pointer"
        (click)="openSettings()"
      >
        settings
      </mat-icon>
    </div>

    <div class="border-b border-solid border-slate-100"></div>
    <div class="flex flex-row flex-wrap gap-8">
      <pt-statistic label="Status">
        {{ store.config()?.dryRun ? 'Dry Run' : 'Active' }}
      </pt-statistic>
      <pt-statistic label="Max Jobs">
        {{ store.config()?.maxJobs ?? 0 | number: '1.0-2' }}
      </pt-statistic>
      <pt-statistic label="Max Job Size">
        {{ store.config()?.maxJobSize ?? 0 | number: '1.0-2' }}
      </pt-statistic>
    </div>
  </div>
  <div class="flex grow flex-col gap-2 rounded-md bg-white p-4 shadow-md">
    <h3 class="!m-0 !font-bold">Bucket</h3>
    <div class="border-b border-solid border-slate-100"></div>
    <div class="flex flex-row flex-wrap gap-8">
      <pt-statistic
        label="Jobs Outstanding"
        matTooltip="Outstanding jobs changed by {{
          summary().jobs.outstandingDelta | number: '1.0-2'
        }} in the past {{ summary().timeDeltaMs | map: formatMsDuation }}"
      >
        {{ summary().jobs.outstanding | number: '1.0-2' }}
        <pt-statistic-delta
          [value]="summary().jobs.outstandingDelta"
          [negativeIsGood]="true"
        >
          {{
            summary().jobs.outstandingDelta / summary().jobs.outstanding
              | percent: '1.0-2'
          }}
        </pt-statistic-delta>
      </pt-statistic>

      <pt-statistic
        label="Files Outstanding"
        matTooltip="Outstanding files changed by {{
          summary().files.outstandingDelta | number: '1.0-2'
        }} in the past {{ summary().timeDeltaMs | map: formatMsDuation }}"
      >
        {{ summary().files.outstanding | number: '1.0-2' }}
        <pt-statistic-delta
          [value]="summary().files.outstandingDelta"
          [negativeIsGood]="true"
        >
          {{
            summary().files.outstandingDelta / summary().files.outstanding
              | percent: '1.0-2'
          }}
        </pt-statistic-delta>
      </pt-statistic>

      <pt-statistic label="Jobs Failed">
        <span [ngClass]="{ 'text-warn-500': summary().jobsInFailedFolder > 0 }">
          {{ summary().jobsInFailedFolder | number: '1.0-2' }}
        </span>
      </pt-statistic>
      <pt-statistic label="Files Failed ">
        <span
          [ngClass]="{ 'text-warn-500': summary().filesInFailedFolder > 0 }"
        >
          {{ summary().filesInFailedFolder | number: '1.0-2' }}
        </span>
      </pt-statistic>
    </div>
  </div>

  <div class="flex grow flex-col gap-2 rounded-md bg-white p-4 shadow-md">
    <h3 class="!m-0 !font-bold">Jobs</h3>
    <div class="border-b border-solid border-slate-100"></div>
    <div class="flex flex-row flex-wrap gap-8">
      <pt-statistic label="Pending">
        {{ summary().jobs.pending | number: '1.0-2' }}
      </pt-statistic>
      <pt-statistic label="In Progress">
        {{ summary().jobs.inProgress | number: '1.0-2' }}
      </pt-statistic>
      <pt-statistic label="Failed">
        <span [ngClass]="{ 'text-warn-500': summary().jobs.failed > 0 }">
          {{ summary().jobs.failed | number: '1.0-2' }}
          @if (summary().jobs.failureRate) {
            ({{ summary().jobs.failureRate | percent: '1.0-2' }})
          }
        </span>
      </pt-statistic>
      <pt-statistic label="Completed">
        {{ summary().jobs.completed | number: '1.0-2' }}
      </pt-statistic>
      <pt-statistic label="Per Min">
        {{ summary().timing.jobsPerMin | number: '1.0-2' }}
      </pt-statistic>
    </div>
  </div>

  <div class="flex grow flex-col gap-2 rounded-md bg-white p-4 shadow-md">
    <h3 class="!m-0 !font-bold">Files</h3>
    <div class="border-b border-solid border-slate-100"></div>
    <div class="flex flex-row flex-wrap gap-8">
      <pt-statistic label="Pending">
        {{ summary().files.pending | number: '1.0-2' }}
      </pt-statistic>
      <pt-statistic label="In Progress">
        {{ summary().files.inProgress | number: '1.0-2' }}
      </pt-statistic>
      <pt-statistic label="Failed">
        <span [ngClass]="{ 'text-warn-500': summary().jobs.failed > 0 }">
          {{ summary().files.failed | number: '1.0-2' }}
          @if (summary().files.failureRate) {
            ({{ summary().files.failureRate | percent: '1.0-2' }})
          }
        </span>
      </pt-statistic>
      <pt-statistic label="Completed">
        {{ summary().files.completed | number: '1.0-2' }}
      </pt-statistic>
      <pt-statistic label="Per Min">
        {{ summary().timing.filesPerMin | number: '1.0-2' }}
      </pt-statistic>
    </div>
  </div>

  <div
    class="col-span-full flex grow flex-col gap-2 rounded-md bg-white p-4 shadow-md"
  >
    <h3 class="!m-0 !font-bold">Overview</h3>
    <div class="border-b border-solid border-slate-100"></div>
    <div class="flex flex-row flex-wrap gap-8">
      <pt-statistic label="Average Run Time">
        {{ summary().timing.averageRunTime | map: formatMsDuation }}
      </pt-statistic>

      <pt-statistic label="Clear Queue ETA">
        {{ summary().clearQueueEtaMs | map: formatMsDuation }}
      </pt-statistic>

      <pt-statistic label="Average Files Per Job">
        {{ summary().averageFilesPerJob | number: '1.0-2' }}
      </pt-statistic>

      <pt-statistic label="Next Run Offset">
        {{ store.latestStat()?.lastJobPointer?.dataset }}.{{
          store.latestStat()?.lastJobPointer?.table
        }}
      </pt-statistic>
    </div>
  </div>
</div>
